import { render, staticRenderFns } from "./DeleteModel.vue?vue&type=template&id=326691d0&scoped=true&"
import script from "./DeleteModel.vue?vue&type=script&lang=js&"
export * from "./DeleteModel.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./DeleteModel.vue?vue&type=style&index=0&id=326691d0&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "326691d0",
  null
  ,true
)

export default component.exports